import React, { PureComponent } from "react";
import { connect } from "react-redux";

import styles from "./DrawerIframe.local.scss";
import classnames from "classnames";

class DrawerIframeComponent extends PureComponent {
  render() {
    const { src, auth } = this.props;

    if (src) {
      let srcUrl =
        src.indexOf("?") === -1
          ? src + "?token=" + auth.token
          : src + "&token=" + auth.token;
      return (
        <iframe
          className={classnames(styles.iframe, src ? styles.opened : "")}
          src={srcUrl}
          title="TAMTAM portal"
        />
      );
    } else {
      return <div style={{ minHeight: "70vh" }} />;
    }
  }
}

// Connected Component
const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(DrawerIframeComponent);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/DrawerIframe/DrawerIframeComponent.js